type Translate = (
  key: string,
  values?: Record<string, string | number>,
) => string

const routeLabels: Record<string, string> = {
  home: 'Home',
  notes: 'Notes',
  memories: 'Memories',
  'to-dos': 'To-Dos',
  ideas: 'Ideas',
  links: 'Links',
  recipes: 'Food',
  movies: 'Movies',
  locations: 'Locations',
  trips: 'Trips',
  protocols: 'Protocols',
  objectives: 'Objectives',
  objective: 'Objective',
  events: 'Events',
  translation: 'Translation',
  whiteboards: 'Whiteboards',
  files: 'Files',
  recordings: 'Lunar',
  scenarios: 'Scenarios',
  settings: 'Settings',
  purchases: 'Purchases',
  income: 'Income',
  search: 'Search',
  information: 'Information',
  wedding: 'Wedding',
}

const searchTypeLabels: Record<string, string> = {
  all: 'All',
  memory: 'Memories',
  todo: 'To-Dos',
  idea: 'Ideas',
  link: 'Links',
  event: 'Events',
  whiteboard: 'Whiteboards',
  vocabulary: 'Vocabulary',
  recipe: 'Recipes',
  movie: 'Movies',
  location: 'Locations',
  objective: 'Objectives',
  file: 'Files',
  protocol: 'Protocols',
}

const fallbackTitle = (value: string) =>
  value
    .split('-')
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ')

export const getRouteTitle = (
  pathname: string,
  t: Translate,
  search: string = '',
) => {
  const parts = pathname.replaceAll('%20', ' ').split('/').filter(Boolean)

  if (!parts.length) {
    return t(routeLabels.home)
  }

  const primarySegment = parts[0]
  const secondarySegment = parts[1]
  const tab = new URLSearchParams(
    search.startsWith('?') ? search.slice(1) : search,
  ).get('tab')

  if (primarySegment === 'notes' && secondarySegment) {
    return t(routeLabels[secondarySegment] || routeLabels.notes)
  }

  if (primarySegment === 'income' && tab === 'analytics') {
    return t('Income analytics')
  }

  if (primarySegment === 'purchases' && tab === 'analytics') {
    return t('Spend analytics')
  }

  return t(routeLabels[primarySegment] || fallbackTitle(primarySegment))
}

export const getDocumentTitle = (
  pathname: string,
  t: Translate,
  search: string = '',
) => {
  const pageTitle = getRouteTitle(pathname, t, search)
  const appName = t('appName')

  return pageTitle === t('Home') ? appName : `${pageTitle} | ${appName}`
}

export const getSearchTypeLabel = (type: string, t: Translate) =>
  t(searchTypeLabels[type] || fallbackTitle(type))
